import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { PunishmentsState } from "@reducers/types/HRM/punishments-state";

import { getPunishmentsRequest } from "@actions/HRM/punishments/punishments-action";
import { getPunishmentsState } from "@selectors/HRM/punishments/punishments-selectors";

import { useAppSelector } from "@helpers/redux";
import { PunishmentType } from "@type/HRM/punishments";
import { PaginationRequestType, PaginationType } from "@type/HRM/pagination";

interface UsePunishments {
  isPunishmentsRequest: boolean;
  isPunishmentsSuccess: boolean;
  isPunishmentsFailed: boolean;
  punishments: PunishmentType[];
  pagination: PaginationType;
  handleQuery: (key: string, value: string | number | null) => void;
  handleOrder: (key: string) => void;
  queryParams: StateType;
}

interface StateType extends PaginationRequestType {
  dateOrder: string;
}

export const usePunishments = (): UsePunishments => {
  const [query, setQuery] = useState<StateType>({
    page: 1,
    size: 10,
    search: "",
    dateOrder: "DESC",
  });

  const handleQuery = (key: string, value: string | number | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const handleOrder = (key: string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: prev[key] === "DESC" ? "ASC" : "DESC",
    }));

  const getPunishments = useAppSelector<PunishmentsState>(getPunishmentsState);

  const isPunishmentsRequest = getPunishments.request as boolean;
  const isPunishmentsSuccess = getPunishments.success as boolean;
  const isPunishmentsFailed = getPunishments.failed as boolean;
  const { data: punishments, pagination } = getPunishments.data || {};

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPunishmentsRequest(query));
  }, [dispatch, query]);

  return {
    handleQuery,
    isPunishmentsRequest,
    isPunishmentsSuccess,
    isPunishmentsFailed,
    punishments,
    pagination,
    handleOrder,
    queryParams: query,
  };
};
